<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Zastosowania</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <strong>Zastosowania</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Zastosowania</h5>
            <span class="ibox-toggle" @click="isMainOpen = !isMainOpen">
              <i :class="chevronMainClass"></i>
            </span>
          </div>
          <div class="ibox-content" v-show="isMainOpen">
            <router-link v-if="canAddAppliance" to="/appliances/create">
              <button class="btn btn-sm btn-primary">Dodaj</button>
            </router-link>
            <div class="row">
              <div class="col-sm-12 m-b-xs">
                <div class="form-group">
                  <label class="control-label col-sm-2">
                    Wpisz liczbę wierszy:
                  </label>
                  <div class="col-sm-2">
                    <input
                      class="form-control inputClass"
                      type="text"
                      v-model="rowsPerPage"
                      @change="setRowsPerPage"
                      @click="isSearch = false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 m-b-xs" v-if="items">
                <button @click="resetFilters" class="btn btn-primary btn-xs">
                  <i class="fa fa-refresh"></i>
                </button>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
                <EasyDataTable
                  v-model:server-options="serverOptions"
                  :server-items-length="itemsAll"
                  :headers="headers"
                  :items="items"
                  :clickRowToExpand="true"
                  :loading="loading"
                  @expand-row="editAppliance"
                  alternating
                  multi-sort
                  border-cell
                  @update-sort="updateSort"
                  class="table-search"
                >
                  <template #header="header">
                    <span v-if="header.text">{{ header.text }}</span>
                    <input
                      class="table-search"
                      type="text"
                      v-if="header.search"
                      v-model="searchValue[header.value]"
                      @keyup="search"
                      @click="isSearch = true"
                    />
                  </template>
                  <template #expand>
                    <div class="row">
                      <div class="col-lg-12">
                        <div class="ibox float-e-margins">
                          <div class="ibox-title">
                            <h5>Opis zastosowania [pl]</h5>
                            <span
                              class="ibox-toggle"
                              @click="isPlOpen = !isPlOpen"
                            >
                              <i :class="chevronPlClass"></i>
                            </span>
                          </div>

                          <div class="form-horizontal">
                            <div class="ibox-content" v-show="isPlOpen">
                              <div class="form-group">
                                <label class="control-label col-sm-2">
                                  Nazwa
                                </label>
                                <div class="col-sm-10">
                                  <input
                                    v-model="applianceObj.name_pl"
                                    type="text"
                                    class="form-control inputClass"
                                    placeholder="Nazwa"
                                    required="required"
                                  />
                                  <div
                                    v-if="errorsAdminData?.data?.name_pl"
                                    class="has-error"
                                  >
                                    <span class="help-block">
                                      {{ errorsAdminData.data.name_pl[0] }}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div class="form-group">
                                <label class="control-label col-sm-2">
                                  Opis
                                </label>
                                <div class="col-sm-10 QuillEditor-box">
                                  <QuillEditor
                                    theme="snow"
                                    contentType="html"
                                    v-model:content="applianceObj.description"
                                  />
                                  <div
                                    v-if="errorsAdminData?.data?.description"
                                    class="has-error"
                                  >
                                    <span class="help-block">
                                      {{ errorsAdminData.data.description[0] }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="ibox float-e-margins">
                          <div class="ibox-title">
                            <h5>Opis zastosowania [en]</h5>
                            <span
                              class="ibox-toggle"
                              @click="isEnOpen = !isEnOpen"
                            >
                              <i :class="chevronEnClass"></i>
                            </span>
                          </div>

                          <div class="form-horizontal">
                            <div class="ibox-content" v-show="isEnOpen">
                              <div class="form-group">
                                <label class="control-label col-sm-2">
                                  Nazwa
                                </label>
                                <div class="col-sm-10">
                                  <input
                                    v-model="applianceObj.name_en"
                                    type="text"
                                    class="form-control inputClass"
                                    placeholder="Nazwa"
                                    required="required"
                                  />
                                  <div
                                    v-if="errorsAdminData?.data?.name_en"
                                    class="has-error"
                                  >
                                    <span class="help-block">
                                      {{ errorsAdminData.data.name_en[0] }}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div class="form-group">
                                <label class="control-label col-sm-2">
                                  Opis
                                </label>
                                <div class="col-sm-10 QuillEditor-box">
                                  <QuillEditor
                                    theme="snow"
                                    contentType="html"
                                    v-model:content="
                                      applianceObj.description_en
                                    "
                                  />
                                  <div
                                    v-if="errorsAdminData?.data?.description_en"
                                    class="has-error"
                                  >
                                    <span class="help-block">
                                      {{
                                        errorsAdminData.data.description_en[0]
                                      }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="ibox float-e-margins">
                          <div class="ibox-title">
                            <h5>Opis zastosowania [de]</h5>
                            <span
                              class="ibox-toggle"
                              @click="isDeOpen = !isDeOpen"
                            >
                              <i :class="chevronDeClass"></i>
                            </span>
                          </div>

                          <div class="form-horizontal">
                            <div class="ibox-content" v-show="isDeOpen">
                              <div class="form-group">
                                <label class="control-label col-sm-2">
                                  Nazwa
                                </label>
                                <div class="col-sm-10">
                                  <input
                                    v-model="applianceObj.name_de"
                                    type="text"
                                    class="form-control inputClass"
                                    placeholder="Nazwa"
                                    required="required"
                                  />
                                  <div
                                    v-if="errorsAdminData?.data?.name_de"
                                    class="has-error"
                                  >
                                    <span class="help-block">
                                      {{ errorsAdminData.data.name_de[0] }}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div class="form-group">
                                <label class="control-label col-sm-2">
                                  Opis
                                </label>
                                <div class="col-sm-10 QuillEditor-box">
                                  <QuillEditor
                                    theme="snow"
                                    contentType="html"
                                    v-model:content="
                                      applianceObj.description_de
                                    "
                                  />
                                  <div
                                    v-if="errorsAdminData?.data?.description_de"
                                    class="has-error"
                                  >
                                    <span class="help-block">
                                      {{
                                        errorsAdminData.data.description_de[0]
                                      }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="ibox float-e-margins">
                          <div class="ibox-title">
                            <h5>Opis zastosowania [de_de]</h5>
                            <span
                              class="ibox-toggle"
                              @click="isDeDeOpen = !isDeDeOpen"
                            >
                              <i :class="chevronDeDeClass"></i>
                            </span>
                          </div>

                          <div class="form-horizontal">
                            <div class="ibox-content" v-show="isDeDeOpen">
                              <div class="form-group">
                                <label class="control-label col-sm-2">
                                  Nazwa
                                </label>
                                <div class="col-sm-10">
                                  <input
                                    v-model="applianceObj.name_cpde"
                                    type="text"
                                    class="form-control inputClass"
                                    placeholder="Nazwa"
                                    required="required"
                                  />
                                  <div
                                    v-if="errorsAdminData?.data?.name_cpde"
                                    class="has-error"
                                  >
                                    <span class="help-block">
                                      {{ errorsAdminData.data.name_cpde[0] }}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div class="form-group">
                                <label class="control-label col-sm-2">
                                  Opis
                                </label>
                                <div class="col-sm-10 QuillEditor-box">
                                  <QuillEditor
                                    theme="snow"
                                    contentType="html"
                                    v-model:content="
                                      applianceObj.description_cpde
                                    "
                                  />
                                  <div
                                    v-if="
                                      errorsAdminData?.data?.description_cpde
                                    "
                                    class="has-error"
                                  >
                                    <span class="help-block">
                                      {{
                                        errorsAdminData.data.description_cpde[0]
                                      }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="ibox float-e-margins">
                          <div class="ibox-title">
                            <h5>Opis zastosowania [de_en]</h5>
                            <span
                              class="ibox-toggle"
                              @click="isDeEnOpen = !isDeEnOpen"
                            >
                              <i :class="chevronDeEnClass"></i>
                            </span>
                          </div>

                          <div class="form-horizontal">
                            <div class="ibox-content" v-show="isDeEnOpen">
                              <div class="form-group">
                                <label class="control-label col-sm-2">
                                  Nazwa
                                </label>
                                <div class="col-sm-10">
                                  <input
                                    v-model="applianceObj.name_cpen"
                                    type="text"
                                    class="form-control inputClass"
                                    placeholder="Nazwa"
                                    required="required"
                                  />
                                  <div
                                    v-if="errorsAdminData?.data?.name_cpen"
                                    class="has-error"
                                  >
                                    <span class="help-block">
                                      {{ errorsAdminData.data.name_cpen[0] }}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div class="form-group">
                                <label class="control-label col-sm-2">
                                  Opis
                                </label>
                                <div class="col-sm-10 QuillEditor-box">
                                  <QuillEditor
                                    theme="snow"
                                    contentType="html"
                                    v-model:content="
                                      applianceObj.description_cpen
                                    "
                                  />
                                  <div
                                    v-if="
                                      errorsAdminData?.data?.description_cpen
                                    "
                                    class="has-error"
                                  >
                                    <span class="help-block">
                                      {{
                                        errorsAdminData.data.description_cpen[0]
                                      }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="ibox float-e-margins">
                          <div class="ibox-title">
                            <h5>Konfiguracja zastosowania</h5>
                            <span
                              class="ibox-toggle"
                              @click="isConfigOpen = !isConfigOpen"
                            >
                              <i :class="chevronConfigClass"></i>
                            </span>
                          </div>

                          <div class="form-horizontal">
                            <div class="ibox-content" v-show="isConfigOpen">
                              <div class="form-group">
                                <label class="control-label col-sm-2">
                                  Obrazek
                                </label>
                                <div class="col-sm-3">
                                  <picture-input
                                    ref="pictureInput"
                                    width="300"
                                    height="300"
                                    margin="16"
                                    accept="image/jpeg,image/png"
                                    :prefill="applianceObj?.icon"
                                    size="10"
                                    button-class="btn"
                                    :custom-strings="{
                                      upload: '<h1>Uploading!</h1>',
                                      drag: 'Drag & Drop',
                                    }"
                                    @change="changePhoto"
                                  >
                                  </picture-input>
                                </div>
                              </div>

                              <div class="hr-line-dashed"></div>

                              <div class="form-group">
                                <div class="col-sm-4 col-sm-offset-2">
                                  <button class="btn btn-white" @click="cancel">
                                    Anuluj
                                  </button>
                                  <button
                                    v-if="canChangeAppliance"
                                    @click="saveEdit"
                                    class="btn btn-primary"
                                  >
                                    Zapisz
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template #item-actions="item">
                    <button
                      v-if="canDeleteAppliance"
                      @click.stop="
                        showModal = item.pk;
                        deleteName = item.name;
                      "
                      class="btn btn-danger btn-xs"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                  </template>
                  <template #item-icon="item">
                    <img v-if="item.icon" :src="item.icon" width="50px" />
                  </template>
                </EasyDataTable>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Modal
    v-if="showModal"
    :title="'Potwierdzenie usunięcia'"
    :content="'Czy na pewno chcesz usunąć <b>' + deleteName + '</b> ?'"
    @callbackOk="deleteAppliance(showModal)"
    @callbackClose="showModal = false"
  />
</template>

<script>
import { computed, watch, ref, onMounted } from "vue";
import { useStore } from "vuex";
import { hasPermission } from "../../permissions";
import { appliancesPermissionsConst } from "../../constants/productionConstants";
import Modal from "../caffeprint/Modal.vue";
import PictureInput from "vue-picture-input";

export default {
  name: "AppliancesList",
  mixins: [],
  components: {
    Modal,
    PictureInput,
  },
  props: {},

  setup() {
    const store = useStore();
    const canAddAppliance = computed(() =>
      hasPermission(appliancesPermissionsConst.add)
    );
    const canChangeAppliance = computed(() =>
      hasPermission(appliancesPermissionsConst.update)
    );
    const canDeleteAppliance = computed(() =>
      hasPermission(appliancesPermissionsConst.delete)
    );
    const deleteAppliancesData = computed(
      () => store.getters.getDeleteAppliancesData
    );
    const applianceData = computed(() => store.getters.getApplianceData);
    const updateAppliancesData = computed(
      () => store.getters.getUpdateAppliancesData
    );
    const appliancesData = computed(() => store.getters.getAppliancesData);
    const applianceObj = ref({});
    let headers = [
      { text: "Obraz", value: "icon", sortable: true, search: true },
      { text: "Nazwa", value: "name", sortable: true, search: true },
      { text: "Opis", value: "description", sortable: true, search: true },
      { text: "Data dodania", value: "date_added", sortable: true },
      { text: "Data modyfikacji", value: "date_modified", sortable: true },
      {
        text: "Zmodyfikowano przez",
        value: "last_modified_by",
        sortable: true,
      },
      {
        text: "Utworzono przez",
        value: "created_by",
        sortable: true,
      },
      { text: "Akcje", value: "actions" },
    ];

    let items = ref([]);
    let itemsAll = ref(0);
    const showModal = ref(false);
    const deleteName = ref("");
    const loading = ref(true);
    const searchValue = ref({});
    const isSearch = ref(false);
    const rowsPerPage = ref();
    const defRowsPerPage = ref(25);
    const serverOptions = ref({
      page: 1,
      rowsPerPage: defRowsPerPage.value,
    });

    const isMainOpen = ref(true);
    const isPlOpen = ref(true);
    const isEnOpen = ref(true);
    const isDeOpen = ref(true);
    const isDeDeOpen = ref(true);
    const isDeEnOpen = ref(true);
    const isConfigOpen = ref(true);

    const chevronMainClass = computed(() =>
      isMainOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronPlClass = computed(() =>
      isPlOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronEnClass = computed(() =>
      isEnOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronDeClass = computed(() =>
      isDeOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronDeDeClass = computed(() =>
      isDeDeOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronDeEnClass = computed(() =>
      isDeEnOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronConfigClass = computed(() =>
      isConfigOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );

    const getAppliances = async () => {
      loading.value = true;
      let sort;
      if (serverOptions.value.sortType === "desc") {
        sort = "-" + serverOptions.value.sortBy;
      } else {
        sort = serverOptions.value.sortBy;
      }
      await store.dispatch("getAppliances", {
        page: serverOptions.value.page,
        itemsPerPage: serverOptions.value.rowsPerPage,
        ordering: sort,
        search: searchValue.value,
      });
    };

    const deleteAppliance = (pk) => {
      showModal.value = false;
      if (!canDeleteAppliance.value) {
        return;
      }
      store.dispatch("deleteAppliances", {
        pk: pk,
      });
    };
    const saveEdit = () => {
      if (!canChangeAppliance.value) {
        return;
      }
      if (typeof applianceObj.value.icon === "string") {
        delete applianceObj.value.icon;
      }
      store.dispatch("updateAppliances", applianceObj.value);
    };

    const cancel = () => {
      document.querySelector(".expanding")?.click();
    };

    const editAppliance = (globalIndex) => {
      cancel();
      const localIndex =
        globalIndex - (serverOptions.value.page - 1) * defRowsPerPage.value;
      store.dispatch("getAppliance", { pk: items.value[localIndex].pk });
    };

    const selectPage = (page) => {
      serverOptions.value.page = page;
    };

    const search = () => {
      isSearch.value = true;
      if (searchValue.value) {
        setTimeout(() => {
          selectPage(1);
          getAppliances();
          isSearch.value = false;
        }, 1000);
      }
    };

    const resetFilters = () => {
      searchValue.value = {};
      selectPage(1);
      serverOptions.value.sortBy = "";
      getAppliances();
    };

    const updateSort = () => {
      search.value = true;
    };

    const changePhoto = (image) => {
      if (image.srcElement?.files[0]) {
        applianceObj.value.icon = image.srcElement?.files[0];
      }
    };

    const setRowsPerPage = () => {
      serverOptions.value.rowsPerPage = rowsPerPage.value;
    };

    onMounted(() => {
      if (localStorage.getItem("appliancesSearchValue") !== null) {
        searchValue.value = localStorage.getItem("appliancesSearchValue");
        searchValue.value = JSON.parse(searchValue.value);
      }

      getAppliances();
    });

    watch(
      () => searchValue.value,
      function () {
        localStorage.setItem(
          "appliancesSearchValue",
          JSON.stringify(searchValue.value)
        );
        getAppliances();
      },
      { deep: true }
    );

    watch(
      () => appliancesData.value,
      function (newValue) {
        itemsAll.value = newValue.data.count;
        items.value = [];
        newValue.data.results?.forEach((element) => {
          items.value.push(element);
        });
        loading.value = false;
      }
    );

    watch(
      () => applianceData.value,
      function (newValue) {
        applianceObj.value = newValue.data;
      }
    );

    watch(
      () => deleteAppliancesData.value,
      function (newValue) {
        if (newValue.status === 204) {
          store.dispatch("showToaster", {
            type: "success",
            content: "Appliance został usuniety",
          });
        }
        getAppliances();
      }
    );

    watch(
      () => updateAppliancesData.value,
      function (newValue) {
        if (newValue.status === 200) {
          getAppliances();
          store.dispatch("showToaster", {
            type: "success",
            content: "Dane zostały zaktualizowane",
          });
        }

        cancel();
      }
    );

    watch(
      () => serverOptions.value,
      function () {
        if (!isSearch.value) {
          getAppliances();
          isSearch.value = false;
        }
      },
      { deep: true }
    );

    return {
      canAddAppliance,
      canChangeAppliance,
      canDeleteAppliance,
      headers,
      items,
      itemsAll,
      loading,
      serverOptions,
      showModal,
      deleteAppliance,
      deleteName,
      applianceObj,
      cancel,
      editAppliance,
      saveEdit,
      searchValue,
      search,
      resetFilters,
      updateSort,
      isSearch,
      rowsPerPage,
      changePhoto,
      setRowsPerPage,
      selectPage,
      isMainOpen,
      isPlOpen,
      isEnOpen,
      isDeOpen,
      isDeDeOpen,
      isDeEnOpen,
      isConfigOpen,
      chevronMainClass,
      chevronPlClass,
      chevronEnClass,
      chevronDeClass,
      chevronDeDeClass,
      chevronDeEnClass,
      chevronConfigClass,
    };
  },
  computed: {},
};
</script>

<style scoped>
.ibox-title {
  position: relative;
}
.ibox-toggle {
  position: absolute;
  right: 15px;
  top: 12px;
  cursor: pointer;
}
</style>
